// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionHoldPeriodDaysPropertyDto
 */
export interface IContributionHoldPeriodDaysPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IContributionHoldPeriodDaysPropertyDto
     */
    contribution_hold_period_days?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionHoldPeriodDaysPropertyDto
     */
    contribution_hold_period_days_state?: IContributionHoldPeriodDaysPropertyDtoContributionHoldPeriodDaysStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IContributionHoldPeriodDaysPropertyDtoContributionHoldPeriodDaysStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IContributionHoldPeriodDaysPropertyDto interface.
 */
export function instanceOfIContributionHoldPeriodDaysPropertyDto(value: object): value is IContributionHoldPeriodDaysPropertyDto {
    return true;
}

export function IContributionHoldPeriodDaysPropertyDtoFromJSON(json: any): IContributionHoldPeriodDaysPropertyDto {
    return IContributionHoldPeriodDaysPropertyDtoFromJSONTyped(json, false);
}

export function IContributionHoldPeriodDaysPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionHoldPeriodDaysPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contribution_hold_period_days': json['contribution_hold_period_days'] == null ? undefined : json['contribution_hold_period_days'],
        'contribution_hold_period_days_state': json['contribution_hold_period_days_state'] == null ? undefined : json['contribution_hold_period_days_state'],
    };
}

export function IContributionHoldPeriodDaysPropertyDtoToJSON(json: any): IContributionHoldPeriodDaysPropertyDto {
    return IContributionHoldPeriodDaysPropertyDtoToJSONTyped(json, false);
}

export function IContributionHoldPeriodDaysPropertyDtoToJSONTyped(value?: IContributionHoldPeriodDaysPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contribution_hold_period_days': value['contribution_hold_period_days'],
        'contribution_hold_period_days_state': value['contribution_hold_period_days_state'],
    };
}

